import { render, staticRenderFns } from "./PlacementBanner.vue?vue&type=template&id=5f5793ee&scoped=true&"
import script from "./PlacementBanner.vue?vue&type=script&lang=ts&"
export * from "./PlacementBanner.vue?vue&type=script&lang=ts&"
import style0 from "./PlacementBanner.vue?vue&type=style&index=0&id=5f5793ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5793ee",
  null
  
)

export default component.exports